export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $('.scrollup').fadeIn();
      } else {
        $('.scrollup').fadeOut();
      }
    });

    $('.scrollup').click(function () {
      $("html, body").animate({
        scrollTop: 0,
      }, 600);
      return false;
    });

    // toggles hamburger and nav open and closed states
    var removeClass = true;
    $(".hamburger").click(function () {
      $(".hamburger").toggleClass('is-active');
      $("#sideNav").toggleClass('sideNav-open');
      $(".sideNavBody").toggleClass('sideNavBody-push');
      removeClass = false;
    });

    $(".sideNav").click(function() {
      removeClass = false;
    });

    document.addEventListener('touchstart', function(e) {
      if (removeClass && !$(e.target).hasClass('sideNav') && $('.sideNav').has($(e.target)).length === 0) {
         $(".hamburger").removeClass('is-active');
         $("#sideNav").removeClass('sideNav-open');
         $(".sideNavBody").removeClass('sideNavBody-push');
      }
      removeClass = true;
    }, false);

    /*global google*/
        var map;
        var infowindow = new google.maps.InfoWindow();

        function initialize_gmap(bound, mapZoom) {
          var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

          var isDraggable = w > 480 ? true : false;

          var settings = {
           zoom: mapZoom,
           center: bound.getCenter(),
           scrollwheel: false,
           draggable: isDraggable,
           mapTypeControl: false,
           mapTypeControlOptions: {
             style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
           },
           navigationControl: false,
           navigationControlOptions: {
             style: google.maps.NavigationControlStyle.SMALL,
           },
           mapTypeId: google.maps.MapTypeId.ROADMAP,

           styles: [{"featureType":"all","elementType":"geometry.fill","stylers":[{"weight":"2.00"}]},{"featureType":"all","elementType":"geometry.stroke","stylers":[{"color":"#9c9c9c"}]},{"featureType":"all","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape","elementType":"labels.text","stylers":[{"color":"#616161"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#eeeeee"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#46bcec"},{"visibility":"on"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#e0e0e0"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#070707"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]}],
          };

          map = new google.maps.Map(document.getElementById("map_canvas"), settings);

          var center;

          google.maps.event.addDomListener(map, 'idle', function() {
           center = map.getCenter();
          });
          google.maps.event.addDomListener(window, 'resize', function() {
           map.setCenter(center);
          });
        }

        function addMarker(point_lat, point_long, address, title, showMarker) {

          var point = new google.maps.LatLng(point_lat, point_long);

          var formattedAddress = address.split(' ').join('+');

          var contentString = '<div id="gmapContent" style="text-align:left;">' +
           '<a href="https://www.google.com/maps/dir/?api=1&destination=' + formattedAddress + '" target="_blank"><h3>' + title + '</h3></a>' +
           '<div id="bodyContent"><p>' + address + '</p>' +
            '<a href="https://www.google.com/maps/dir/?api=1&destination=' + formattedAddress + '" target="_blank">' +
            '<i class="fa fa-external-link"></i> <strong>Get Directions</strong></a></div></div>';

          var companyMarker = new google.maps.Marker({
           position: point,
           map: map,
           title: title,
          });

          if( showMarker === true ) {
           infowindow.setContent(contentString);
           infowindow.open(map, companyMarker);
          }

          google.maps.event.addListener(companyMarker, 'click', function() {
            infowindow.setContent(contentString);
            infowindow.open(map, this);
          });

        }

        var locations = [];

        $('.location-map').each(function() {
          var location = [];
          location.push(parseFloat($(this).find('.map-data').find('.lat').data('lat')));
          location.push(parseFloat($(this).find('.map-data').find('.lng').data('lng')));
          location.push($(this).find('.map-data').find('.address').data('address'));
          location.push($(this).find('.map-data').find('.title').data('title'));
          locations.push(location);
        });


        if ($('#map_canvas').length) {
          var i;
          var showMarker = true;
          var mapZoom = $('.map-panel').find('.zoom').data('zoom');
          var offset = 0.00008 * (Math.pow(2, -mapZoom + 20));
          if( locations.length > 1 ) {
           showMarker = false;
           offset = 0;
          }
          var bound = new google.maps.LatLngBounds();
          for (i = 0; i < locations.length; i++) {
           bound.extend(new google.maps.LatLng((locations[i][0] + offset), locations[i][1]));
          }
          initialize_gmap(bound, mapZoom);
          for (i = 0; i < locations.length; i++) {
           addMarker(locations[i][0], locations[i][1], locations[i][2], locations[i][3], showMarker);
          }
        }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js